import MediaControl from './media_control'
export default MediaControl
